export default {
  en: {
    'components.permissions-table.header.section': 'Section',
    'components.permissions-table.header.view': 'View',
    'components.permissions-table.header.modify': 'Modify',
  },
};
